import React from "react";
import styles from "./TicketDetail.module.scss";
import GenButton from "./GenButton";
import GenPrompt from "./GenPrompt";
import AddNote from "./AddNote";
import {ReactComponent as Closer} from './../assets/close.svg';
import {DataService} from './../store/DataService';
import { RELATIONSHIPS, APPTREASONS, ACTIONADDNOTE, ACTIONREASONS, formatPhoneNumber, Date12, STATEID_CLOSED, STATEID_QUEUE,
    MSGTYPE_APPTREQUEST,MSGTYPE_APPTCANCEL,MSGTYPE_APPTINQUIRY,MSGTYPE_APPTRESCHEDULE, PRIORITIES, 
    PRIORITY_HOLDING,MSGTYPE_REFERRAL,MSGTYPE_INT_TRANSFER,MSGTYPE_RX,
    CALLTYPE_APPT_CANCEL} from "./../AppConstants";
import GenConfirm from './GenConfirm';
import GenTertiary from "./GenTertiary";

const TicketDetail = (props) => {
    const tk = props.ticket || {};
    if (tk.priority===PRIORITY_HOLDING) {
        tk.holding = 1;
    } else {
        tk.holding = 0;
    }
    
    const msg = tk.msg || {};
    const [ticket,setTicket] = React.useState(tk);
    const [ticketpriority,setTicketPriority] = React.useState(tk.priority || 0);
    const [msgdetail,setMsgDetail] = React.useState(msg.detail || {});
    const [msginfo,setMsgInfo] = React.useState(msg.info || []);
    const [msgevents,setMsgEvents] = React.useState(msg.events || []);
    const [msgactions,setMsgActions] = React.useState(msg.actions || []);
    const [msghistory,setMsgHistory] = React.useState(msg.history || []);
    const [workflow,setWorkFlow] = React.useState(tk.workflow || []);
    const [shownote,setShowNote] = React.useState(false);
    const [showevents,setShowEvents] = React.useState(false);
    const [showisholding,setShowIsHolding] = React.useState(false);
    const [showclosed,setShowClosed] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);

    const [reasons, setReasons] = React.useState([]);
    const [showReasonModal, setShowReasonModal] = React.useState(false);
    const [selectedReasonId, setSelectedReasonId] = React.useState(0);
    const [pendingUnavailReasonId, setPendingUnavailReasonId] = React.useState(null);

    React.useEffect(() => {
        if (!props.globals || !props.globals.sessionguid) return;
        const dataservice = new DataService({guid: props.globals.sessionguid});
        dataservice.getunavailreasons().then((rdata) => {
            if (rdata.REASONS) {
                setReasons(rdata.REASONS);
                if (rdata.REASONS.length > 0) {
                    setSelectedReasonId(rdata.REASONS[0].reasonid);
                }
            }
        });
    }, [props.globals.sessionguid]);

    const [ptFirstName, setPtFirstName] = React.useState(msg.detail?.PatientFirstName || "");
    const [ptLastName, setPtLastName] = React.useState(msg.detail?.PatientLastName || "");
    const [ptDOB, setPtDOB] = React.useState(msg.detail?.PatientDOB || "");
    const [isEditingPt, setIsEditingPt] = React.useState(false);

    // Sync props.ticket changes dynamically
    React.useEffect(() => {
        if (props.ticket) {
            setTicket(props.ticket);
            if (props.ticket.workflow) {
                setWorkFlow(props.ticket.workflow);
            }
            if (props.ticket.msg) {
                if (props.ticket.msg.detail) setMsgDetail(props.ticket.msg.detail);
                if (props.ticket.msg.info) setMsgInfo(props.ticket.msg.info);
                if (props.ticket.msg.events) setMsgEvents(props.ticket.msg.events);
                if (props.ticket.msg.actions) setMsgActions(props.ticket.msg.actions);
                if (props.ticket.msg.history) setMsgHistory(props.ticket.msg.history);
            }
        }
    }, [props.ticket]);

    // Acknowledge screen pop for RESERVED tickets to trigger grace timer before phone rings
    const poppedTicketRef = React.useRef(null);
    const activeTicketId = ticket?.ticketid || tk?.ticketid || 0;
    React.useEffect(() => {
        if (!props.globals || !props.globals.sessionguid || !activeTicketId) return;
        const currentStatus = ticket?.eventstatus || ticket?.Status || ticket?.ticketstatus;
        const isReserved = (currentStatus === 7 || currentStatus === 'RESERVED' || ticket?.eventname === 'RESERVED' || tk?.eventname === 'RESERVED' || tk?.eventstatus === 7);
        if (isReserved && poppedTicketRef.current !== activeTicketId) {
            poppedTicketRef.current = activeTicketId;
            const dataservice = new DataService({guid: props.globals.sessionguid});
            dataservice.logticketpop(props.globals.useraccountid, activeTicketId).catch(err => {
                console.error('[POP-ACK] Error logging ticket pop from TicketDetail:', err);
            });
        }
    }, [activeTicketId, ticket, props.globals]);

    // Poll readticketdetail every 6s to dynamically update state (e.g. RESERVED -> INPROGRESS)
    const isDetailPolling = React.useRef(false);
    React.useEffect(() => {
        if (!props.globals || !props.globals.sessionguid || !activeTicketId) return;
        const interval = setInterval(() => {
            if (isDetailPolling.current) return;
            isDetailPolling.current = true;
            const dataservice = new DataService({guid: props.globals.sessionguid});
            dataservice.readticketdetail(props.globals.useraccountid, activeTicketId)
                .then((tdData) => {
                    if (tdData && tdData.TICKET) {
                        setTicket(tdData.TICKET);
                        if (tdData.TICKET.workflow) {
                            setWorkFlow(tdData.TICKET.workflow);
                        }
                        if (tdData.TICKET.msg) {
                            if (tdData.TICKET.msg.events) setMsgEvents(tdData.TICKET.msg.events);
                            if (tdData.TICKET.msg.history) setMsgHistory(tdData.TICKET.msg.history);
                        }
                    }
                })
                .finally(() => {
                    isDetailPolling.current = false;
                });
        }, 6000);
        return () => clearInterval(interval);
    }, [props.globals.sessionguid, props.globals.useraccountid, activeTicketId]);
    
    const [transcript, setTranscript] = React.useState("");
    const [showTranscript, setShowTranscript] = React.useState(false);

    const toStateRef = React.useRef(0);
    const askholding = React.useRef(props.askholding || false);

    const toggleEditPt = () => {
        setIsEditingPt(!isEditingPt);
    }

    const savePatientInfo = () => {
        const dataservice = new DataService({guid:props.globals.sessionguid});
        dataservice.updatepatientinfo(ticket.ticketid, msgdetail.MsgID, ptFirstName, ptLastName, ptDOB).then((data) => {
            if (data.ERROR) {
                if (data.ERROR.length > 0) {
                    alert(data.ERROR);
                    return;
                }
            }
            setIsEditingPt(false);
            // Update local state to reflect changes
            let newDetail = {...msgdetail};
            newDetail.PatientFirstName = ptFirstName;
            newDetail.PatientLastName = ptLastName;
            newDetail.PatientDOB = ptDOB;
            setMsgDetail(newDetail);
        })
    }

    const allowpriorityedit = React.useRef(props.allowpriorityedit || false);

    const loadTranscript = () => {
        if (!ticket.transcript_path) return;
        const dataservice = new DataService({guid:props.globals.sessionguid});
        dataservice.gettranscript(ticket.transcript_path).then((data) => {
            if (data.ERROR) {
                alert(data.ERROR);
                return;
            }
            setTranscript(data.TRANSCRIPT);
            setShowTranscript(true);
        })
    }

    const fromsearch = React.useRef(props.fromsearch || false);
    const disableworkflow = React.useRef(props.disableworkflow || false);

    const getStatusNormalized = React.useCallback(() => {
        const name = (
            ticket?.TicketName ||
            ticket?.ticketname ||
            ticket?.eventname ||
            ticket?.EventName ||
            ticket?.TicketStatus ||
            ticket?.statusname ||
            ticket?.StatusName ||
            ""
        ).toString().toUpperCase().replace(/[\s-]/g, "");
        return name;
    }, [ticket]);

    // -------------------------------------------------------------------------
    // 10-Second WRAPUP Timeout & Extend Logic (Agent Working View Only)
    // -------------------------------------------------------------------------
    const currentStatusInt = parseInt(
        ticket?.status || 
        ticket?.Status || 
        ticket?.eventstatus || 
        ticket?.EventStatus || 
        ticket?.ticketstatus || 
        ticket?.TicketStatus || 
        ticket?.msg?.detail?.Status || 0, 10
    );
    const normStatus = getStatusNormalized();
    const isWrapupState = (currentStatusInt === 14 || normStatus === 'WRAPUP' || normStatus === '14');
    const isAgentActiveWork = !fromsearch.current && !disableworkflow.current && !props.showClosed;

    // isAdmin declared above with wrapup/live-call state

    const hasLiveCall = Boolean(
        ticket?.callsid || 
        ticket?.CallSID || 
        msgdetail?.CallSID || 
        msgdetail?.callsid ||
        ticket?.holding === 1 || 
        ticket?.washolding === 1 || 
        ticket?.priority === PRIORITY_HOLDING ||
        ticketpriority === PRIORITY_HOLDING
    );

    const isLiveCallActive = Boolean(
        hasLiveCall && 
        isAgentActiveWork && 
        !isWrapupState && 
        currentStatusInt !== STATEID_CLOSED && 
        normStatus !== 'CLOSED' && 
        currentStatusInt !== 12
    );



    const [wrapupTimeLeft, setWrapupTimeLeft] = React.useState(10);
    const [isWrapupWarning, setIsWrapupWarning] = React.useState(false);
    const [isWrapupAutoClosing, setIsWrapupAutoClosing] = React.useState(false);
    const prevWrapupKey = React.useRef(null);

    // Reset wrapup timer ONCE when active ticket enters wrapup state (prevents resets during background polling)
    React.useEffect(() => {
        const wrapupKey = `${activeTicketId}_${isWrapupState}_${isAgentActiveWork}`;
        if (isWrapupState && isAgentActiveWork) {
            if (prevWrapupKey.current !== wrapupKey) {
                prevWrapupKey.current = wrapupKey;
                setWrapupTimeLeft(10);
                setIsWrapupWarning(false);
                setIsWrapupAutoClosing(false);
            }
        } else {
            prevWrapupKey.current = wrapupKey;
        }
    }, [activeTicketId, isWrapupState, isAgentActiveWork]);

    const triggerWrapupAutoClose = React.useCallback(() => {
        if (isWrapupAutoClosing) return;
        setIsWrapupAutoClosing(true);

        const dataservice = new DataService({ guid: props.globals.sessionguid });
        const tid = ticket.ticketid || tk.ticketid;

        // 1. Save auto-close history note
        const noteObj = {
            msgid: msgdetail.MsgID || 0,
            msgtype: msgdetail.MessageTypeID || 0,
            respid: msgdetail.ResponsibleID || 0,
            resptype: msgdetail.ResponsibleType || "",
            uacid: props.globals.useraccountid,
            actionid: ACTIONADDNOTE,
            cmt: "Auto-closed: Exceeded 10-second WRAPUP inactivity timeout",
            reason: "Auto-Closed",
            ctmeth: "", ctpersonid: 0, ctgroupid: 0,
            auacid: props.globals.useraccountid,
            apracid: props.globals.userpracticeid,
            recname: ""
        };

        dataservice.savenote(noteObj).finally(() => {
            // 2. Transition ticket to CLOSED (STATEID_CLOSED = 12)
            doAction(tid, STATEID_CLOSED, 0);
        });
    }, [isWrapupAutoClosing, props.globals, ticket, tk, msgdetail]);

    // Countdown interval loop
    React.useEffect(() => {
        if (!isWrapupState || !isAgentActiveWork || isWrapupAutoClosing) return;

        const timer = setInterval(() => {
            setWrapupTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    triggerWrapupAutoClose();
                    return 0;
                }
                const nextVal = prev - 1;
                if (nextVal <= 3) {
                    setIsWrapupWarning(true);
                }
                return nextVal;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [isWrapupState, isAgentActiveWork, isWrapupAutoClosing, activeTicketId, triggerWrapupAutoClose]);

    const handleExtendWrapup = () => {
        const dataservice = new DataService({ guid: props.globals.sessionguid });
        
        // 1. Reset timer back to 10 seconds
        setWrapupTimeLeft(10);
        setIsWrapupWarning(false);

        // 2. Log extension history note
        const noteObj = {
            msgid: msgdetail.MsgID || 0,
            msgtype: msgdetail.MessageTypeID || 0,
            respid: msgdetail.ResponsibleID || 0,
            resptype: msgdetail.ResponsibleType || "",
            uacid: props.globals.useraccountid,
            actionid: ACTIONADDNOTE,
            cmt: "Agent extended wrapup timeout (+10s)",
            reason: "Timer Extended",
            ctmeth: "", ctpersonid: 0, ctgroupid: 0,
            auacid: props.globals.useraccountid,
            apracid: props.globals.userpracticeid,
            recname: ""
        };

        dataservice.savenote(noteObj).then(() => {
            // Update local history display
            let hist = {
                CreateDate: new Date(),
                Who: "Agent",
                ActionTaken: "Timer Extended",
                Details: "Agent extended wrapup timeout (+10s)",
                EditRows: []
            };
            let msghist = JSON.parse(JSON.stringify(msghistory));
            msghist.push(hist);
            setMsgHistory(msghist);
        });
    };

    //const statuses = ['Closed','Open','2','3','4','5','6'];
    const statuses = ['Open','Open','Open','Open','Open','Open','Open','Open','Open','Open','Open','Open','Closed','13','14'];
    const fdate = msgdetail.CreateDate || "";
    const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric'};
    const fd = new Date(fdate);
    const fmted = fd.toLocaleDateString(undefined,options);
    const timeopts = {hour:"numeric",minute:"numeric",hour12:true};
    const fmttime = fd.toLocaleTimeString("en-us",timeopts);
    let ptdob = new Date(msgdetail.PatientDOB).toLocaleDateString(undefined,options);
    if (ptdob==="Invalid Date" || ptdob.indexOf("1900") >= 0) ptdob = "";
    if (ptdob.length > 0) {
        ptdob += " (" + msgdetail.PatientAge+")";
    }
    const patient = msgdetail.PatientFirstName + " " + msgdetail.PatientLastName;
    const pfn = msgdetail.ProvFirstName || "";
    const midin = msgdetail.MiddleInitial || "";
    const pln = msgdetail.ProvLastName || "";
    const cr = msgdetail.CallerRelationship || "";

    let relationship = "";
    if (cr.length > 0) {
        relationship = RELATIONSHIPS[cr];
    }
    let provider = pfn + " ";
    if (midin.length > 0) {
        provider += midin + " "
    }
    provider += pln;
    const cfn = msgdetail.CallerFirstName || "";
    const cln = msgdetail.CallerLastName || "";
    const caller = cfn + " " + cln;
    const inf = msgdetail.info || [];
    const hasinfo = inf.length > 0;
    //const pracname = msgdetail.PracName || "";
    const pracname = tk.pracname || "";
    const tmsg = "Ticket details ("+ pracname + ")";
    const isappt = [MSGTYPE_APPTCANCEL,MSGTYPE_APPTINQUIRY,MSGTYPE_APPTRESCHEDULE,MSGTYPE_APPTREQUEST,MSGTYPE_REFERRAL].includes(msgdetail.MessageTypeID);
    const isrequest = msgdetail.MessageTypeID === MSGTYPE_APPTREQUEST;
    const isrefill = msgdetail.MessageTypeID === MSGTYPE_RX;
    let newpt = 'N';
    if (isrequest) {
        newpt = msgdetail.NewPatient || 'N';
    }
    let andisabled = false;
    let sc = props.showClosed || false;
    if (sc) andisabled = true;
    

    let cbdisabled = false;
    let cbtitle = "";
    let isclosed = false;
    if (props.showClosed === true) {
        cbtitle = "Cannot close while Showing Closed Messages.";
        cbdisabled = true;
    }
    if (msgdetail.Ack==='N') {
        cbtitle = "Message has not been Acknowledged yet.";
        cbdisabled = true;
    }
    if (msgdetail.Status===0) {
        cbtitle = "Message already closed.";
        cbdisabled = true;
        if (props.globals.intext===1) isclosed = true;
    }
    const dummy = (ticketid,stateid,priority) => {}
    const dummy2 = (e) => {}

    const isReserved = (
        getStatusNormalized() === "RESERVED" ||
        parseInt(ticket?.status, 10) === 7 ||
        parseInt(ticket?.eventstatus, 10) === 7 ||
        parseInt(ticket?.ticketstatus, 10) === 7 ||
        parseInt(ticket?.TicketStatus, 10) === 7 ||
        parseInt(ticket?.Status, 10) === 7
    );

    const isAdmin = Boolean(
        fromsearch.current ||
        props.globals?.fmticadmin === true ||
        (props.globals?.roleid && parseInt(props.globals.roleid, 10) === 2)
    );

    const isCloseDisabled = Boolean(
        !isAdmin &&
        isAgentActiveWork &&
        isReserved
    );

    const onClose = (e) => {
        if (isCloseDisabled) {
            alert("Ticket is currently reserved for an incoming call. Please answer or wait for the call to connect before closing.");
            return;
        }

        const statusStr = getStatusNormalized();
        if (statusStr === "INPROGRESS" || ticket?.status === 3 || ticket?.eventstatus === 3) {
            try {
                window.dispatchEvent(new CustomEvent("webphone:hangup"));
            } catch (err) {
                console.warn("webphone:hangup error:", err);
            }
        }

        const cb = props.doClose || dummy;
        cb(0,0,0);
    }

    const addNote = (e) => {
        setShowNote(true);
    }

    const cancelNote = () => {
        setShowNote(false);
    }

    const saveNote = (reason,cmt) => {
        const dataservice = new DataService({guid:props.globals.sessionguid});
        cmt = cmt.replaceAll(/(?:\r\n|\r|\n)/g, '<br>');


        let obj = {
            msgid:msgdetail.MsgID,
            msgtype:msgdetail.MessageTypeID,
            respid:msgdetail.ResponsibleID,
            resptype:msgdetail.ResponsibleType,
            uacid:props.globals.useraccountid,
            actionid:ACTIONADDNOTE,
            cmt:cmt,
            reason:reason,
            ctmeth:"",
            ctpersonid:0,
            ctgroupid:0,
            auacid:props.globals.useraccountid,
            apracid:props.globals.userpracticeid,
            recname:""
        }
        dataservice.savenote(obj).then((data) => {
                if (data.ERROR) {
                    if (data.ERROR.length > 0) {
                        alert(data.ERROR);
                        return;
                    }
                }
                setShowNote(false);
                //onClose(0);
                let hist = {
                    CreateDate:new Date(),
                    Who:"Practice Admin",
                    ActionTaken: "Notes Added",
                    Details:cmt + " - Practice Admin",
                    EditRows:[]

                }
                let msghist = JSON.parse(JSON.stringify(msghistory));
                msghist.push(hist);
                setMsgHistory(msghist);
            })
        
    }

    const doAction = (ticketid,stateid,priority,holding=0) => {
        setShowIsHolding(false);
        if (holding===1) priority = PRIORITY_HOLDING;
        setSubmitting(true);
        const dataservice = new DataService({guid:props.globals.sessionguid});
        dataservice.gototicketstate(ticketid,stateid,priority,props.globals.useraccountid,holding).then((data)=> {
            if (data.ERROR) {
                if (data.ERROR.length > 0) {
                    alert(data.ERROR);
                    setSubmitting(false);
                    return;
                }
            }

            if (data.hasOwnProperty('ACTION')) {
                let action = data.ACTION;
                if (action === 'inuse') {
                    alert("Notice: This ticket was closed or updated by another user/system. The detail view will now close.");
                    setSubmitting(false);
                    const cb = props.doClose || dummy;
                    cb(ticketid, STATEID_QUEUE, priority, pendingUnavailReasonId);
                    return;
                }
            }
            
            if (ticketid > 0 && holding > 0 && stateid === STATEID_QUEUE) {
                window.focus();
                navigator.clipboard.writeText(''+ticketid).then(() => {
                    alert('Ticket # '+ticketid+' was copied to clipboard. Please Paste it into Phone System.');
                })
                .catch((err) => {
                    console.error('Failed to copy text: ', err);
                    alert('Failed to copy text. Please manually Copy/Paste the ticket #'+ticketid);
                });
            }
            
            const cb = props.doClose || dummy;
            cb(ticketid,stateid,priority,pendingUnavailReasonId);
        }).catch(() => {
            setSubmitting(false);
        })
    }

    const onActionYes = () => {
        const afnc = props.onAction || doAction;
        afnc(ticket.ticketid,toStateRef.current,ticketpriority,1);        
    }
    const onActionNo = () => {
        const afnc = props.onAction || doAction;
        afnc(ticket.ticketid,toStateRef.current,ticketpriority,0);
    }
    const onActionCancel = () => {
        setShowIsHolding(false);
    }

    const onAction = (stateid) => {
        console.log("ActionID="+stateid);
        // Allow agent to close/resolve stuck or phantom reserved ticket if caller hung up
        // (Previously blocked non-admins, causing agents to get trapped on ghost tickets)
        toStateRef.current = stateid;
        if (askholding.current===true && ticket.holding===0 && ticket.washolding > 0 && stateid !== STATEID_CLOSED) {
            setShowIsHolding(true);
        } else {
            const afnc = props.onAction || doAction;
            afnc(ticket.ticketid,stateid,ticketpriority,ticket.holding);    
        }
    }

    const onActionHold = (e) => {
        toStateRef.current = STATEID_QUEUE;
        onActionYes();
    }

    const ShowWorkflow = () => {
        let hasip = false;
        let ipmsg = 'Note: Press "In-Progress" to take ownership of this ticket.';
        let isclosed = ticket.ticketname === 'CLOSED';
        if (fromsearch.current) {
            if (isclosed) return null;
            return (
                <React.Fragment>
                <div style={{marginTop:"10px",display:"flex",gap:"16px",alignItems:"center",height:"40px"}}>
                    <div style={{marginTop:"12px",fontSize:"18px",fontWeight:"bold",height:"30px",alignItems:"center"}}>Available Actions:</div>
                    <GenButton 
                        onclick={(e)=>{
                            setShowClosed(true);
                        }} 
                        id={ticket.ticketid} 
                        buttontext={"Close Ticket"}
                        bgcolor="white"
                        color="black"
                        width="120"
                        height="30"
                        disabled={submitting}
                    />

                    {ticket.priority !== PRIORITY_HOLDING && <GenButton
                        onclick={onActionHold} 
                        id={ticket.ticketid} 
                        buttontext={"Put On-Hold"}
                        bgcolor="white"
                        color="black"
                        width="120"
                        height="30"
                        disabled={submitting}
                    />
                    }
                
                    </div>
                </React.Fragment>
                
            )
        }
        return (
            <React.Fragment>
                <div style={{marginTop:"10px",display:"flex",gap:"16px",alignItems:"center",height:"40px"}}>
                    <div style={{marginTop:"12px",fontSize:"18px",fontWeight:"bold",height:"30px",alignItems:"center"}}>Available Actions:</div>
                    {workflow.map((wf,i)=> {
                        let btxt = wf.buttontext;
                        if (btxt==="In-Progress") {
                            hasip = true;
                            if (ticket.holding > 0) {
                                btxt = 'Continue';
                                ipmsg = 'Note: Press "Continue" to take ownership of this ticket.';
                            }
                        }
                        const isCloseAction = (
                            (btxt || "").toLowerCase().includes("close") ||
                            wf.workflowstateid === STATEID_CLOSED ||
                            wf.workflowstateid === 12
                        );
                        const isBtnDisabled = submitting || (isCloseDisabled && isCloseAction);
                        return (
                            <div key={'wf_'+i}>
                                <GenButton 
                                    onclick={(id) => {
                                        if (isCloseDisabled && isCloseAction) {
                                            alert("Ticket is currently reserved for an incoming call. Please answer or wait for the call to connect before closing.");
                                            return;
                                        }
                                        onAction(id);
                                    }} 
                                    id={wf.workflowstateid} 
                                    buttontext={btxt}
                                    bgcolor="white"
                                    color="black"
                                    width="120"
                                    height="30"
                                    disabled={isBtnDisabled}
                                    title={(isCloseDisabled && isCloseAction) ? "Close is disabled while ticket is reserved for incoming call." : ""}
                                    />
                            </div>
                        )
                    })}
                    {hasip && <div style={{fontSize:"14px",fontStyle:"italic"}}>{ipmsg}</div>}
                    {isCloseDisabled && (
                        <div style={{fontSize:"13px", color:"#b91c1c", fontStyle:"italic", fontWeight:"bold", display:"flex", alignItems:"center"}}>
                            Note: Close is disabled while ticket is reserved.
                        </div>
                    )}
                    <div style={{marginLeft: "auto"}}>
                        <GenButton 
                            onclick={() => setShowReasonModal(true)} 
                            id={0} 
                            buttontext={pendingUnavailReasonId ? `Unavailable (${reasons.find(r => r.reasonid === pendingUnavailReasonId)?.reason || "Pending"})` : "Unavailable"}
                            bgcolor={pendingUnavailReasonId ? "#ffc107" : "white"}
                            color="black"
                            width="160"
                            height="30"
                            disabled={submitting}
                        />
                    </div>
                </div>
            </React.Fragment>
        )
    }

    const handleState = (e) => {
        const val = e.target.value;
        setTicketPriority(val);
    }

    const ENABLE_STATUS_COLORS = false; // Set to true to re-enable state background colors

    const getStatusStyle = (statusName, isholding) => {
        if (!ENABLE_STATUS_COLORS) {
            return { backgroundColor: "white", color: "black" };
        }
        const s = (statusName || "").toUpperCase().replace("-", "");
        if (s === "RESERVED") return { backgroundColor: "#FEF08A", color: "black" };   // Bright Soft Yellow
        if (s === "INPROGRESS") return { backgroundColor: "#86EFAC", color: "black" }; // Rich Medium Green
        if (s === "WRAPUP") return { backgroundColor: "#FCA5A5", color: "black" };     // Rich Light Red
        if (isholding) return { backgroundColor: "rgb(245, 245, 78)", color: "black" };
        return { backgroundColor: "white", color: "black" };
    };

    const ShowTicket = () => {
        let hasqueue = false;
        let isholding = ticket.holding===1 || ticket.washolding===1 || ticket.priority === PRIORITY_HOLDING;
        let holdmsg = isholding ? " (HOLDING)" : "";
        let statusStyle = getStatusStyle(ticket.ticketname, isholding);

        if (allowpriorityedit.current) {
            workflow.map((wf,i)=> {
                if (wf.buttontext=="In-Queue") {
                    hasqueue = true;
                }
            });    
        }
        const showPriorities = () => {
            return (
                <div><b>Priority:</b> 
                <select style={{marginLeft:"6px",height:"24px",fontSize:"16px"}} name="selpri" value={ticketpriority} onChange={handleState}>
                    {PRIORITIES.map((p,i)=> {
                        if (p.indexOf('OMG+') >= 0) return null;
                        return <option key={i} value={i}>{p}</option>
                    })}
                </select>
                </div>
            )
        }
        return (
            <div style={{marginTop:"10px"}}>
                <div className={styles.tkrow}>
                    <div><b>Ticket #:</b> {ticket.ticketid}</div>
                    {!hasqueue && <div><b>Priority:</b> {PRIORITIES[ticketpriority]}</div>}
                    {hasqueue && showPriorities()}
                    <div style={{...statusStyle, padding: "2px 8px", borderRadius: "4px", display: "inline-block"}}>
                        <b>Status:</b> {ticket.ticketname} <span style={{fontSize:"18px",fontWeight:"bold"}}>{holdmsg}</span>
                    </div>
                </div>
                <div className={styles.tkrow} style={{marginTop:"6px"}}>
                    <div><b>Message Type:</b> {ticket.msgname}</div>
                    <div><b>Created:</b> {Date12(ticket.createdate)}</div>
                    <div><b>Callback Phone:</b> {ticket.callbackphone}</div>
                </div>
                {!disableworkflow.current && <ShowWorkflow />}
            </div> 
        )
    }

    const formatEventDate = (dateStr) => {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return dateStr;
        
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = months[d.getMonth()];
        const day = d.getDate();
        const year = d.getFullYear();
        
        let hh = d.getHours();
        const mm = String(d.getMinutes()).padStart(2, '0');
        const ss = String(d.getSeconds()).padStart(2, '0');
        const ampm = hh >= 12 ? 'PM' : 'AM';
        
        hh = hh % 12;
        hh = hh ? hh : 12; // the hour '0' should be '12'
        const hhStr = String(hh).padStart(2, '0');
        
        return `${month} ${day} ${year}, ${hhStr}:${mm}:${ss} ${ampm}`;
    };

    const ShowHistory = () => {
        
        if (!msghistory.length) {
            return (
                <React.Fragment>
                <div className={styles.partheader}>History</div>
                <div>No History for this message</div>
                </React.Fragment>
            )
        }
        return (
            <React.Fragment>
            <div className={styles.partheader}>History</div>
            {msghistory.map((obj,i) => {
                let det = obj.Details.replaceAll(/(?:\r\n)/g, '<br>');
                let edits = obj.EditRows || [];
                console.log("detail "+det);
                det = det.split('<br>');
                let msgdate = formatEventDate(obj.CreateDate);
                return (
                    <div key={'hist_'+i}>
                        <div className={styles.histrowhdr}>
                            <div>Date</div><div>Event</div><div>Who</div><div>Details</div>
                        </div>
                        <div className={styles.histrow}>
                            <div>{msgdate}</div><div>{obj.ActionTaken}</div><div>{obj.Who || obj.Recipient || "System"}</div><div className={styles.details}>
                                {det.map((ln,i)=> {
                                    if (!ln.length) ln = "\n";
                                    return <div key={"ln_"+i} className={styles.newline}>{ln}</div>
                                })}
                                {edits.map((ln,i)=> {
                                    if (!ln.length) ln = "\n";
                                    return <div key={"lned_"+i} className={styles.newline}>{ln}</div>
                                })}
                            </div>
                        </div>
                    </div>
                )
            })}
            </React.Fragment>
        )
    }

    const ShowMessage = () => {
        const mbody = msgdetail.MessageBody || "";
        const details = mbody.split("\n");
        const setext = showevents ? "Hide Events" : "Show Events";
        const mtid = msgdetail.MessageTypeID===MSGTYPE_APPTCANCEL | msgdetail.MessageTypeID === MSGTYPE_APPTRESCHEDULE;
        const isreferral = msgdetail.MessageTypeID===MSGTYPE_REFERRAL;
        const msgcc = msgdetail.CancelConfirm==='C' ? "Cancel" : "Confirm";
        const resch = msgdetail.Reschedule==='Y' ? "Reschedule" : "No Reschedule";

        const handleFNChange = (e) => setPtFirstName(e.target.value);
        const handleLNChange = (e) => setPtLastName(e.target.value);
        const handleDOBChange = (e) => setPtDOB(e.target.value);

        const handleDOBBlur = (e) => {
            let val = e.target.value;
            if (!val) return;
            
            // Try to handle common formats
            let d = new Date(val);
            if (!isNaN(d.getTime())) {
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                const yyyy = d.getFullYear();
                setPtDOB(`${mm}/${dd}/${yyyy}`);
            }
        }

        const showEditButton = (patient.trim().length === 0 || patient === "- -") && !isEditingPt;

        return (
            <React.Fragment>
            <hr/>
            <div className={styles.detailheader}>
                <div style={{display:"flex", alignItems:"center", gap:"10px"}}>
                    Message Details<span style={{fontSize:"18px"}}>(# {msgdetail.MsgID})</span>
                    {showEditButton && <GenButton 
                        onclick={toggleEditPt} 
                        buttontext="Edit Patient"
                        bgcolor="white"
                        color="black"
                        width="100"
                        height="24"
                        fontSize="12px"
                    />}
                </div>
            </div>
            {shownote && <AddNote globals={props.globals} methods={props.methods} onSave={saveNote} onCancel={cancelNote} showreason={false} />}
        
            <div className={styles.lefthalf}>
                <div className={styles.listrowhdr}>
                    <div>Msg Date</div><div>Msg Time</div><div>Status</div>
                </div>
                <div className={styles.listrow}>
                    <div>{fmted}</div><div>{fmttime}</div><div>{statuses[msgdetail.Status]}</div>
                </div>
                <div className={styles.listrowhdr}>
                    <div>Patient {isEditingPt && "(First / Last)"}</div><div>Date of Birth</div><div>Provider</div>
                </div>
                <div className={styles.listrow}>
                    {!isEditingPt && <div>{patient}</div>}
                    {isEditingPt && <div style={{display:"flex", gap:"4px"}}>
                        <input type="text" value={ptFirstName} onChange={handleFNChange} style={{width:"80px"}} placeholder="First" />
                        <input type="text" value={ptLastName} onChange={handleLNChange} style={{width:"80px"}} placeholder="Last" />
                    </div>}

                    {!isEditingPt && <div>{ptdob}</div>}
                    {isEditingPt && <div>
                        <input type="text" value={ptDOB} onChange={handleDOBChange} onBlur={handleDOBBlur} style={{width:"100px"}} placeholder="MM/DD/YYYY" />
                    </div>}

                    <div>{provider}</div>
                </div>
                {isEditingPt && <div style={{display:"flex", gap:"10px", marginTop:"4px", marginBottom:"10px"}}>
                    <GenButton onclick={savePatientInfo} buttontext="Save" bgcolor="green" color="white" width="60" height="24" />
                    <GenButton onclick={toggleEditPt} buttontext="Cancel" bgcolor="red" color="white" width="60" height="24" />
                </div>}
                <div className={styles.listrowhdr}>
                <div>Msg Type</div><div>Caller</div><div>Relationship</div>
                </div>
                <div className={styles.listrow}>
                <div>{msgdetail.Name}</div><div>{caller}</div><div>{relationship}</div>
                </div>
                <div className={styles.listrowhdr}>
                <div>Callback Phone</div>
                <div>CallSID</div>
                {mtid > 0 ? (
                  <div>Cancel/Confirm</div>
                ) : isreferral ? (
                  <div>Referral Num</div>
                ) : isrequest ? (
                  <div>New Patient</div>
                ) : (
                  <div></div>
                )}
                </div>
                <div className={styles.listrow}>
                <div>{formatPhoneNumber(msgdetail.CallbackPhone)}</div>
                <div style={{overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}} title={ticket.callsid || ""}>{ticket.callsid || ""}</div>
                {mtid > 0 ? (
                  <div>{msgcc}{msgdetail.CancelConfirm==='C' && <span> ({resch})</span>}</div>
                ) : isreferral ? (
                  <div>{msgdetail.ReferralNum}</div>
                ) : isrequest ? (
                  <div>{newpt}</div>
                ) : (
                  <div></div>
                )}
                </div>
                {isappt && <ShowAppt />}
                {hasinfo && <ShowInfo />}
                
            </div>
            <div className={styles.righthalf}>
                <div><b>Message</b><br/>
                    {details.map((det,i)=> {
                        return <div key={"detail_"+i}>{det}</div>
                    })}
                </div>
                <div className={styles.actionheader2}>

                    <div style={{width:"30px"}}>&nbsp;</div>
                </div>
            </div>
            <ShowHistory />
            <div style={{marginTop:"10px",display:"flex"}}>
            <div>
                <GenButton 
                onclick={onClose} 
                id={msgdetail.MsgID} 
                buttontext="Close Detail"
                bgcolor="white"
                color="black"
                width="100"
                height="30"
                disabled={submitting || isCloseDisabled}
                title={isCloseDisabled ? "Ticket is currently reserved for an incoming call." : ""}
                />
            </div>
            {ticket.transcript_path && <div style={{marginLeft:"20px"}}>
                <GenButton 
                onclick={loadTranscript} 
                id="view_transcript" 
                buttontext="View Transcript"
                bgcolor="white"
                color="black"
                width="120"
                height="30"
                />
            </div>}
            <div style={{marginLeft:"20px"}}>
                <GenButton globals={props.globals} methods={props.methods}
                    buttontext="Add Note"
                    id="0"
                    preicon="plus"
                    iconcolor="black"
                    bgcolor="white"
                    color="black"
                    width="100"
                    height="30"
                    onclick={addNote}
                    disabled={andisabled}
                    />
            </div>
            <div style={{marginLeft:"20px"}}>
                <GenButton globals={props.globals} methods={props.methods}
                    buttontext={setext}
                    id="0"
                    bgcolor="white"
                    color="black"
                    width="100"
                    height="30"
                    onclick={()=>setShowEvents(!showevents)}
                    disabled={false}
                    />
            </div>
        </div>
        </React.Fragment>
        )
    }

    const ShowAppt = () => {
        //const reason = APPTREASONS[msgdetail.Reason || "5"];
        const reason = msgdetail.ApptDesc || "";
        const doptions = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour:'numeric',minute:'numeric',hours12:true};
        //const doptions = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric'};
        let apptdate = "";
        const ad = msgdetail.ApptDate || "";
        if (ad.length > 0) {
            const dt = new Date(ad);
            apptdate = dt.toLocaleDateString(undefined,doptions);
            if (apptdate.indexOf("Mon, Jan 1, 1900") === 0) {
                if (apptdate.indexOf(", 00:00") > 0 || apptdate.indexOf(", 12:00 AM") > 0) {
                    apptdate = "";
                } else {
                    apptdate = apptdate.replace("Mon, Jan 1, 1900, ","");
                }
                
            }
        }
        const apptloc = msgdetail.LocationName || "";
 
        return (
            <React.Fragment>
            <div className={styles.partheader}>Appointment Data</div>
            <div className={styles.listrowhdr}>
                <div>Date</div><div>Location</div><div>Reason</div>
            </div>
            <div className={styles.listrow}>
                <div>{apptdate}</div><div>{apptloc}</div><div>{reason}</div>
            </div>
            </React.Fragment>
        )
    }

    const ShowInfo = () => {
        return (
            <React.Fragment>
            <div className={styles.partheader}>Extra Information</div>
            <div className={styles.listrowhdr}>
                {msginfo.map((obj,i) => {
                    return <div key={'desc_'+i}>{obj.Description}</div>
                })}
            </div>
            <div className={styles.listrow}>
                {msginfo.map((obj,i) => {
                    return <div key={'val_'+i}>{obj.Val}</div>
                })}
            </div>
            </React.Fragment>
        )
    }

    const ShowEvents = () => {
        const events = ticket.events || [];

        return (
            <React.Fragment>
            <div className={styles.partheader}>Ticket Events (Workflow)</div>
            <div className={styles.evrowhdr}>
                <div>Datetime</div>
                <div>State</div>
                <div>Priority</div>
                <div>Username</div>
            </div>
            {events.map((ev,i)=> {
                const evid = ev.ticketeventid;
                const evdate = formatEventDate(ev.eventdate || "");
                const evstatus = ev.statusname || "CREATE";
                const evpri = ev.priname || "";
                const evuser = ev.username || "";
                const evStyle = getStatusStyle(evstatus, false);
                return (
                    <div key={i} className={styles.evrow}>
                        <div>{evdate}</div>
                        <div style={{...evStyle, padding: "1px 6px", borderRadius: "3px", display: "inline-block"}}>{evstatus}</div>
                        <div>{evpri}</div>
                        <div>{evuser}</div>
                    </div>
                )
            })}
            </React.Fragment>
        )
    }

    const saveCloseReason = (cmt) => {
        setSubmitting(true);
        const dataservice = new DataService({guid:props.globals.sessionguid});
        //cmt = cmt.replaceAll(/(?:\r\n|\r|\n)/g, '<br>');

        cmt = cmt.replaceAll(/(?:\r\n|\r|\n)/g, '<br>');


        let obj = {
            msgid:msgdetail.MsgID,
            msgtype:msgdetail.MessageTypeID,
            respid:msgdetail.ResponsibleID,
            resptype:msgdetail.ResponsibleType,
            uacid:props.globals.useraccountid,
            actionid:ACTIONADDNOTE,
            cmt:cmt,
            reason:'Ticket Close',
            ctmeth:"",
            ctpersonid:0,
            ctgroupid:0,
            auacid:props.globals.useraccountid,
            apracid:props.globals.userpracticeid,
            recname:""
        }
        dataservice.savenote(obj).then((data) => {
            if (data.ERROR) {
                if (data.ERROR.length > 0) {
                    alert(data.ERROR);
                    setSubmitting(false);
                    return;
                }
            }
            try {
                window.dispatchEvent(new CustomEvent("webphone:hangup"));
            } catch (err) {}
            const cb = props.closeticket || dummy2;
            cb(0);
            const close_cb = props.doClose || dummy;
            close_cb(0, 12, 0, pendingUnavailReasonId);
        }).catch(() => {
            setSubmitting(false);
        })
        
    }

    const doCloseCancel = () => {
        setShowClosed(false);
    }

    const doCloseOK = (cmt) => {
        setShowClosed(false);
        saveCloseReason(cmt);
    }
    let isholding = ticket.holding===1 || ticket.washolding===1 || ticket.priority===PRIORITY_HOLDING;
    let bgcolor = isholding ? "rgb(245, 245, 78)" : "white";
    return (
        <React.Fragment>
            <div className={styles.detail} style={{backgroundColor:bgcolor}}>
                <div className={styles.outer}>
                    <div className={styles.inner}>
                        <div className={styles.detailheader}>
                            <div>{tmsg}</div>
                            <div 
                                className={styles.headerright} 
                                onClick={onClose}
                                style={{
                                    cursor: isCloseDisabled ? "not-allowed" : "pointer",
                                    opacity: isCloseDisabled ? 0.35 : 1
                                }}
                                title={isCloseDisabled ? "Ticket is currently reserved" : "Close Detail"}
                            >
                                <Closer />
                            </div>
                        </div>
                        {isWrapupState && isAgentActiveWork && (
                            <div style={{
                                backgroundColor: isWrapupWarning ? "#dc3545" : "#ffc107",
                                color: isWrapupWarning ? "#ffffff" : "#212529",
                                border: "1px solid " + (isWrapupWarning ? "#bd2130" : "#ffe8a1"),
                                padding: "10px 16px",
                                borderRadius: "6px",
                                margin: "10px 0",
                                fontWeight: "bold",
                                fontSize: "15px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                boxShadow: isWrapupWarning ? "0 0 12px rgba(220, 53, 69, 0.8)" : "none",
                                transition: "all 0.3s ease"
                            }}>
                                <div>
                                    {isWrapupWarning 
                                        ? `🚨 WRAPUP TIMEOUT WARNING: Ticket auto-closing in ${wrapupTimeLeft} seconds!`
                                        : `⏱️ Wrapup Timeout: ${wrapupTimeLeft}s remaining until auto-close.`}
                                </div>
                                <button
                                    onClick={handleExtendWrapup}
                                    style={{
                                        backgroundColor: isWrapupWarning ? "#ffffff" : "#0056b3",
                                        color: isWrapupWarning ? "#dc3545" : "#ffffff",
                                        border: "none",
                                        padding: "6px 14px",
                                        borderRadius: "4px",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        fontSize: "13px",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                    }}
                                >
                                    Extend Wrapup (+10s)
                                </button>
                            </div>
                        )}
                        {(ticket.ticketname === 'CLOSED' || msgdetail.Status === 0) && (
                            <div style={{backgroundColor:"#fff3cd",color:"#856404",border:"1px solid #ffeeba",padding:"10px 14px",borderRadius:"4px",margin:"10px 0",fontWeight:"bold",fontSize:"14px"}}>
                                ⚠️ Notice: This ticket is CLOSED (Auto-closed due to inactivity or completed). Any new notes will be saved as additional comments.
                            </div>
                        )}
                        <ShowTicket />
                        {ShowMessage()}
                        {showevents && <ShowEvents />}
                        {showclosed && <GenPrompt 
                            text={"Reason for Closing #" + ticket.ticketid + ":"} 
                            onConfirm={doCloseOK} 
                            onCancel={doCloseCancel} 
                            inpvalue={""} 
                            width={300} 
                            />}

                        {showisholding && <GenTertiary 
                            globals={props.globals} 
                            methods={props.methods}
                            width="580"
                            text="Is caller still Holding on-line?"
                            onCancel = {onActionCancel}
                            onYes = {onActionYes}
                            onNo = {onActionNo}
                            />}

                        {showTranscript && (
                            <div className={styles.detail} style={{zIndex:1000}}>
                                <div className={styles.outer}>
                                    <div className={styles.inner} style={{width:"80%", height:"80%"}}>
                                        <div className={styles.detailheader}>
                                            <div>Call Transcript</div>
                                            <div className={styles.headerright} onClick={()=>setShowTranscript(false)}><Closer /></div>
                                        </div>
                                        <div style={{padding:"20px", overflowY:"auto", height:"calc(100% - 60px)", whiteSpace:"pre-wrap", backgroundColor:"white", color:"black", textAlign:"left"}}>
                                            {transcript}
                                        </div>
                                        <div style={{marginTop:"10px", padding:"10px"}}>
                                            <GenButton 
                                                onclick={()=>setShowTranscript(false)} 
                                                buttontext="Close Transcript"
                                                bgcolor="white"
                                                color="black"
                                                width="120"
                                                height="30"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {showReasonModal && (
                            <div style={{
                                position: 'fixed',
                                top: 0, left: 0, right: 0, bottom: 0,
                                backgroundColor: 'rgba(0,0,0,0.5)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 9999
                            }}>
                                <div style={{
                                    backgroundColor: '#fff',
                                    padding: '24px',
                                    borderRadius: '8px',
                                    width: '350px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                    color: '#000'
                                }}>
                                    <h3 style={{marginTop: 0, marginBottom: '16px', fontSize: '18px', fontWeight: 'bold'}}>Select Unavailable Reason</h3>
                                    <div style={{marginBottom: '20px'}}>
                                        <label style={{display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 'bold'}}>Reason:</label>
                                        <select 
                                            value={selectedReasonId} 
                                            onChange={(e) => setSelectedReasonId(parseInt(e.target.value))}
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                borderRadius: '4px',
                                                border: '1px solid #ccc',
                                                fontSize: '15px'
                                            }}
                                        >
                                            {reasons.map((r) => (
                                                <option key={r.reasonid} value={r.reasonid}>{r.reason}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div style={{display: 'flex', justifyContent: 'flex-end', gap: '12px'}}>
                                        <GenButton 
                                            onclick={() => setShowReasonModal(false)}
                                            id={0}
                                            buttontext="Cancel"
                                            bgcolor="white"
                                            color="black"
                                            width="80"
                                            height="30"
                                        />
                                        <GenButton 
                                            onclick={() => {
                                                setPendingUnavailReasonId(selectedReasonId);
                                                setShowReasonModal(false);
                                            }}
                                            id={0}
                                            buttontext="Confirm"
                                            bgcolor="yellow"
                                            color="black"
                                            width="80"
                                            height="30"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

        </React.Fragment>
    )
}

export default TicketDetail;